<template>
  <section class="well hero is-large">
    <video
      :src="$localized('coverVideo')"
      :poster="$localized('coverPreview')"
      :style="{ transform: `translateY(${parallax}px)` }"
      loop
      muted
      autoplay
    ></video>
    <div class="overlay"></div>
    <div class="hero-body">
      <div class="container">
        <h1 class="title has-text-centered">
          {{ $t("commons.programName") }}
        </h1>
        <div class="subtitle has-text-centered is-size-3">
          {{ $t("home.titleDescription") }}
        </div>
        <div class="buttons is-centered">
          <a :href="$localized('appV6')" class="button is-large is-fixed-width"
            ><span class="icon is-medium"
              ><img
                alt=""
                class="downloads__icon"
                src="@/assets/images/shared/online.svg"
            /></span>
            <span>{{ $t("home.buttonRunOnline") }}</span></a
          >
          <router-link
            :to="{ path: '/download' }"
            class="button is-success is-large is-fixed-width"
            ><span class="icon is-medium"
              ><img
                alt=""
                class="downloads__icon"
                src="@/assets/images/shared/download-fff.svg"
            /></span>
            <span>{{ $t("home.buttonDownload") }}</span></router-link
          >
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      scrollListener: null,
      parallax: 0
    };
  },
  mounted() {
    this.scrollListener = () => {
      this.parallax = document.documentElement.scrollTop / 2;
    };

    window.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollListener);
  }
};
</script>
